




















































































import { Vue, Component, Prop } from 'vue-property-decorator';

import FilterTag from '@/componentsV2/molecules/FilterTag/FilterTag.vue';
import Close from '@/components/icons/Close.vue';

@Component({
  components: {
    FilterTag,
    Close
  }
})
export default class EmailPreview extends Vue {
  @Prop({ default: false }) modal?: boolean;
  @Prop() title!: string;
  @Prop() subject!: string;
  @Prop() previewText!: string;

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get emailFrom() {
    return 'do-not-reply@emails.twism.com';
  }
}
